import React from 'react';
import { useLocation } from 'react-router';
import * as styles from './AiAskWidget.module.scss';
import Button from '../components/Button';
import Card from '../components/Card';
import IconButton from '../components/IconButton';
import SVGIcon from '../components/SVGIcon';
import closeIcon from '../icons/non-prefilled/16x16/clear.svg';
import aiIcon from '../icons/prefilled/16x16/ai.svg';
import { getAiAskLocation } from '../utils/search/aiAsk';

interface AiAskWidgetProps {
  close: () => void;
}

const AiAskWidget = ({ close }: AiAskWidgetProps) => {
  const location = useLocation();
  return (
    <div className={styles.widget}>
      <Card>
        <div className={styles.header}>
          <div className={styles.title}>
            <SVGIcon>{aiIcon}</SVGIcon>
            <h5>AI Ask</h5>
          </div>
          <IconButton
            applyNegativeMargin
            aria-label="Close"
            onClick={() => close()}
          >
            {closeIcon}
          </IconButton>
        </div>
        <div className={styles.content}>
          Your query looks like a question. Do you want to ask Slab’s AI for an
          answer?
          <br />
          <Button
            className={styles.button}
            variant="secondary"
            size="small"
            to={getAiAskLocation(location)}
          >
            Ask question
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default AiAskWidget;
